import { render, staticRenderFns } from "./TabReduce.vue?vue&type=template&id=342830d0&scoped=true&"
import script from "./TabReduce.vue?vue&type=script&lang=ts&"
export * from "./TabReduce.vue?vue&type=script&lang=ts&"
import style0 from "./TabReduce.vue?vue&type=style&index=0&id=342830d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342830d0",
  null
  
)

export default component.exports